import request from '../../config/axiosConfig';
import {
  GET_LIST_SERVICE_LDPS, GET_SERVICE_LDP_INFO, CREATE_SERVICE_LDP,
  UPDATE_SERVICE_LDP, DELETE_SERVICE_LDP
} from '../../constants/apiEndPoint';

export const getListServiceLdpsRequest = async (data) => {
  const result = await request({ url: GET_LIST_SERVICE_LDPS, method: 'POST', data });
  return result?.data.data;
};

export const getServiceLdpInfoRequest = async (data) => {
  const result = await request({ url: GET_SERVICE_LDP_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createServiceLdpRequest = async (data) => {
  const result = await request({ url: CREATE_SERVICE_LDP, method: 'POST', data });
  return result?.data;
};

export const updateServiceLdpRequest = async (data) => {
  const result = await request({ url: UPDATE_SERVICE_LDP, method: 'POST', data });
  return result?.data;
};

export const deleteServiceLdpRequest = async (data) => {
  const result = await request({ url: DELETE_SERVICE_LDP, method: 'POST', data });
  return result?.data;
};
